import React, { useRef } from 'react'
import CanvasDraw from './react-canvas-draw'
import classNames from 'classnames'
import injectSheet from 'react-jss'

export const WORK_HIGHLIGHT_SETTINGS = {
  markerColors: [
    'rgba(160, 190, 23, .35)',
    'rgba(233, 35, 174, .35)',
    'rgba(254, 228, 51, .35)',
    'rgba(129, 94, 165, .35)'
  ],
  markerSizes: [32, 24, 16, 12],
  penColors: [
    'rgb(160, 190, 23)',
    'rgb(233, 35, 174)',
    'rgb(254, 228, 51)',
    'rgb(129, 94, 165)'
  ],
  penSizes: [12, 8, 4, 2]
}

const markerStyles = {
  canvas: {
    pointerEvents: 'none',
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100% !important',
    height: '100% !important',
    background: 'transparent !important'
  },
  enable: {
    pointerEvents: 'auto'
  }
}

export const useWorkHighlighter = () => {
  const actionsQueue = useRef([])
  return {
    undo: () => {
      if (actionsQueue.current.length) {
        actionsQueue.current.pop().undo()
      }
    },
    onAction: instance => {
      actionsQueue.current.push(instance)
    }
  }
}

export const WorkHighlighter = injectSheet(markerStyles)(
  // eslint-disable-next-line no-unused-vars
  ({ canvasRef, classes, settings, controls, preloadData, key, ...props }) => {
    return (
      <CanvasDraw
        saveData={preloadData || null}
        ref={canvasRef}
        brushRadius={
          !controls
            ? undefined
            : controls.activeTool === 'marker'
            ? controls.toolSettings.markerSize / 2
            : controls.activeTool === 'pen'
            ? controls.toolSettings.penSize / 2
            : 20
        }
        brushColor={
          !controls
            ? undefined
            : controls.activeTool === 'marker'
            ? controls.toolSettings.markerColor
            : controls.activeTool === 'pen'
            ? controls.toolSettings.penColor
            : '#000'
        }
        hideGrid
        lazyRadius={2}
        hideInterface
        erasing={controls && controls.activeTool === 'eraser'}
        className={classNames(classes.canvas, {
          [classes.enable]:
            controls &&
            (controls.activeTool === 'marker' ||
              controls.activeTool === 'pen' ||
              controls.activeTool === 'eraser')
        })}
        {...props}
      />
    )
  }
)
